// src/app/guards/auth.guard.ts

import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { Router } from '@angular/router';

export const authGuard: CanActivateFn = (): Promise<boolean> => {
  const router = inject(Router);
  const auth = getAuth();

  return new Promise(resolve => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      unsubscribe();
      if (user) {
        resolve(true);
      } else {
        router.navigateByUrl('/se-connecter');
        resolve(false);
      }
    });
  });
};
